import styled from "styled-components";
import { GREEN } from "../constant/Colors";
import * as React from "react";
import { ReactNode, useEffect, useState } from "react";
import { mod } from "../technical/mod";

const WordColumn = styled.span<{ center?: boolean }>`
  display: inline-flex;
  flex-direction: column;
  align-items: ${({ center }) => (center ? "center" : "flex-start")};
  max-height: 1em;
`;

const Word = styled.span<{ translateY: number; visible: boolean }>`
  transform: translateY(-${({ translateY }) => translateY}00%);
  transition: all 0.6s ease;
  color: ${GREEN};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
`;

interface Props {
  words: ReactNode[];
  center?: boolean;
}

export const WordShift = ({ words, center }: Props) => {
  const [activeWord, setActiveWord] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveWord(oldWord => {
        return mod(oldWord + 1, words.length);
      });
    }, 2000 + Math.random() * 1000);

    return () => {
      clearInterval(interval);
    };
  }, [words]);

  return (
    <WordColumn center={center}>
      {words.map((word, i) => (
        <Word key={i} translateY={activeWord} visible={activeWord === i}>
          {word}
        </Word>
      ))}
    </WordColumn>
  );
};
